import { Box, Text } from '@chakra-ui/react';

const Error = () => {
  return (
    <Box width='100%' display='flex' justifyContent='center' alignItems='center'>
      <Text color='red.500'>
        Failed to load. Please try again later.
      </Text>
    </Box>
  );
};

export default Error;